import { render, staticRenderFns } from "./SelectorChecklist.vue?vue&type=template&id=12aa27c4&scoped=true"
import script from "./SelectorChecklist.vue?vue&type=script&lang=js"
export * from "./SelectorChecklist.vue?vue&type=script&lang=js"
import style0 from "./SelectorChecklist.vue?vue&type=style&index=0&id=12aa27c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12aa27c4",
  null
  
)

export default component.exports